<label class="switch">
  <input id="checkbox" type="checkbox" [(ngModel)]="value" [disabled]="disabled" />
  <span class="slider round"></span>
</label>
